import { Box, Typography } from '@mui/material';
import ReusableTabs from '../UIElements/ReusableTabs';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import CampaignIcon from '@mui/icons-material/Campaign';
import FeeStructure from './FeeStructure';
import HomeWorkTab from './HomeWorkTab';
import AnnouncementTab from './AnnouncementTab';
import { useSelector } from 'react-redux';
const ConfigurationPage = () => {
  const { userDetails, mobileServices } = useSelector(
    (state) => state.auth?.successData ?? {},
  );
  const Tabs = [
    userDetails &&
      userDetails?.mobileService &&
      mobileServices?.homework && {
        label: 'HomeWork',
        icon: <PendingActionsOutlinedIcon />,
        content: <HomeWorkTab />,
      },
    userDetails &&
      userDetails?.mobileService &&
      mobileServices?.announcements && {
        label: 'Announcements',
        icon: <CampaignIcon />,
        content: <AnnouncementTab />,
      },
    userDetails &&
      userDetails?.role?.toLowerCase() === 'admin' && {
        label: 'Fee Structure',
        icon: <ReceiptLongIcon className='size-8 ' />,
        content: <FeeStructure />,
      },
  ].filter(Boolean);
  return (
    <>
      <Box className='p-4'>
        <Box className='bg-blue-50 p-4 rounded-lg'>
          <Typography variant='h6' className='text-blue-700 font-bold'>
            Manage Applicaiton Configurations
          </Typography>
          <Typography variant='body1' className='text-gray-600'>
            Handle all configurations like Fee Structure,Home works etc...
          </Typography>
        </Box>
        {Tabs?.length > 0 ? (
          <ReusableTabs
            tabs={Tabs}
            variant='scrollable'
            allowScrollButtons={true}
            className='w-full'
          />
        ) : (
          <div className='flex items-center justify-center  h-80'>
            <Typography className='text-blue-600'>
              Only Admin can view this page
            </Typography>
          </div>
        )}
      </Box>
    </>
  );
};
export default ConfigurationPage;
